import {
  Checkbox,
  FormControlLabel,
  Grid,
  ListItemIcon,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Menu } from "@mui/icons-material";
import { useEffect, useState } from "react";
import DropdownComponent from "../../../../../App/Components/Dropdown/DropdownComponent";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },

  itemIcon: {
    cursor: "grab",
  },
  tableCell: {
    color: theme.palette.primary.copy,
  },
}));

export default function TalentNetworkDisplayTableCell(props) {
  const classes = useStyles(props);

  const [selectedCustom, setSelectedCustom] = useState({});

  useEffect(() => {
    if (props.element.propertyName === "customfield") {
      setSelectedCustom(
        props.element.customId !== undefined
          ? props.element.customId
          : props.element.customFields[0]
      );
      props.element.customFields.forEach((c) => {
        if (c.id === props.element.customId) {
          setSelectedCustom(c);
          props.element.customId = c.id;
          return;
        }
      });
    }
  }, [props.element]);

  function changeSelectedCustom(func, index, val) {
    func(val);
    var temp = [...props.tableData];
    temp[index].customId = val.id;
    props.setTableData(temp);
  }

  function changeLabel(index, val) {
    var temp = [...props.tableData];
    temp[index].label = val;
    props.setTableData(temp);
  }

  function changePlaceholder(index, val) {
    var temp = [...props.tableData];
    temp[index].placeholder = val;
    props.setTableData(temp);
  }

  function changeHelp(index, val) {
    var temp = [...props.tableData];
    temp[index].help = val;
    props.setTableData(temp);
  }

  function changeSelected(index) {
    var temp = [...props.tableData];
    temp[index].selected = !temp[index].selected;
    props.setTableData(temp);
  }

  return (
    <>
      <TableRow
        hover
        className={props.index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={props.index}
        ref={props.innerRef}
        {...props}
      >
        {props.columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "Selected" ? (
              <FormControlLabel
                style={{ marginTop: "10px" }}
                control={
                  <Checkbox
                    color="primary"
                    checked={props.element.selected}
                    onChange={() => changeSelected(props.index)}
                  />
                }
                label=""
              />
            ) : column.label === "Display Label" ? (
              props.element.propertyName !== "isuserinternal" ? (
                <TextField
                  placeholder="Display Label"
                  label="Display Label"
                  variant="standard"
                  fullWidth
                  style={{ minWidth: "100px" }}
                  InputProps={{
                    className: classes.tableCell,
                  }}
                  value={props.element.label}
                  onChange={(e) => changeLabel(props.index, e.target.value)}
                />
              ) : (
                <TextField
                  placeholder="Have you worked with us before?"
                  label="Have you worked with us before?"
                  variant="standard"
                  fullWidth
                  InputProps={{
                    className: classes.tableCell,
                  }}
                  style={{ minWidth: "100px" }}
                  disabled
                />
              )
            ) : column.label === "Display Placeholder" ? (
              props.element.propertyName !== "isuserinternal" ? (
                <TextField
                  placeholder="Display Placeholder"
                  label="Display Placeholder"
                  variant="standard"
                  fullWidth
                  style={{ minWidth: "100px" }}
                  InputProps={{
                    className: classes.tableCell,
                  }}
                  value={props.element.placeholder}
                  onChange={(e) =>
                    changePlaceholder(props.index, e.target.value)
                  }
                />
              ) : (
                <TextField
                  placeholder="Have you worked with us before?"
                  label="Have you worked with us before?"
                  variant="standard"
                  fullWidth
                  style={{ minWidth: "100px" }}
                  InputProps={{
                    className: classes.tableCell,
                  }}
                  disabled
                />
              )
            ) : column.label === "Help Text" ? (
              <TextField
                placeholder="Help Text"
                label="Help Text"
                variant="standard"
                fullWidth
                style={{ minWidth: "100px" }}
                InputProps={{
                  className: classes.tableCell,
                }}
                value={props.element.help}
                onChange={(e) => changeHelp(props.index, e.target.value)}
              />
            ) : column.label === "" ? (
              <ListItemIcon className={classes.itemIcon}>
                <Menu />
              </ListItemIcon>
            ) : (
              props.element[column.propName]
            )}
            {column.label === "Admin Text" &&
            props.element.propertyName === "customfield" ? (
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <DropdownComponent
                    currValue={selectedCustom}
                    items={props.element.customFields}
                    property="name"
                    title="Default"
                    handleChange={(value) =>
                      changeSelectedCustom(
                        setSelectedCustom,
                        props.index,
                        value
                      )
                    }
                  />
                </Grid>
              </Grid>
            ) : null}
          </TableCell>
        ))}
      </TableRow>
    </>
  );
}
